export class EnaioFrontendSortColumn {
    title = "";
    ascending = true;

    constructor(title: string, ascending = true) {
        this.title = title;
        this.ascending = ascending;
    }
}
